import React from 'react';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TContentCardsProps = {
  kind?: 'grid';
  className?: string;
  children?: React.ReactNode;
  as?: 'section' | 'ul';
};

const ContentCards = ({ kind, as = 'section', ...rest }: TContentCardsProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return <Box {...rest} {...conditionalProps} as={as} name="ContentCards" />;
};

export default ContentCards;
